import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app"
};
const _hoisted_2 = {
  class: "app-top"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Drawer = _resolveComponent("Drawer");
  const _component_Header = _resolveComponent("Header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_Footer = _resolveComponent("Footer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$setup.drawerOpen ? (_openBlock(), _createBlock(_component_Drawer, {
    key: 0,
    "total-price": $setup.totalPrice,
    class: "basket"
  }, null, 8, ["total-price"])) : _createCommentVNode("", true), _createVNode(_component_Header, {
    onOpenDrawer: $setup.openDrawer,
    onCloseDrawer: $setup.closeDrawer,
    "notif-count": 5,
    "favorite-count": $setup.countFavorite,
    "cart-count": $setup.cart.length
  }, null, 8, ["onOpenDrawer", "onCloseDrawer", "favorite-count", "cart-count"])]), _createVNode(_component_router_view), _createVNode(_component_Footer)]);
}